import { useState } from 'react';
import { SELECTION_MODE_SINGLE } from '_utils/constant';

export const createDefaultSubItemGroup = () => ({
  id: Date.now() + Math.random(),
  title: '',
  selectionMode: SELECTION_MODE_SINGLE, // 'single' | 'multiple'
  trackInventory: false,
  required: false,
  choices: [
    { id: Date.now() + Math.random(), name: '', price: '', maxQty: '' }
  ]
});

export default function useSubItems({
  initialGroups,
  onChange,
} = {}) {
  const [groups, setGroups] = useState(
    initialGroups && initialGroups.length > 0 ? initialGroups : [createDefaultSubItemGroup()]
  );
  const [isHidden, setIsHidden] = useState(false);

  const updateGroups = (newGroups) => {
    setGroups(newGroups);
    if (onChange) {
      onChange(newGroups);
    }
  };

  const toggleHidden = () => {
    setIsHidden((prev) => !prev);
  };

  const handleAddSubItem = () => {
    updateGroups([...groups, createDefaultSubItemGroup()]);
  };

  const handleRemoveGroup = (groupId) => {
    updateGroups(groups.filter((g) => g.id !== groupId));
  };

  const handleGroupTitleChange = (groupId, title) => {
    updateGroups(
      groups.map((g) => (g.id === groupId ? { ...g, title } : g))
    );
  };

  const handleSelectionModeChange = (groupId, selectionMode, trackInventory = false) => {
    updateGroups(
      groups.map((g) => (g.id === groupId ? {
        ...g,
        selectionMode,
        trackInventory,
        required: g.required
      } : g))
    );
  };

  const handleRequiredToggle = (groupId) => {
    updateGroups(
      groups.map((g) => (g.id === groupId ? { ...g, required: !g.required } : g))
    );
  };

  const handleAddChoice = (groupId) => {
    updateGroups(
      groups.map((g) => {
        if (g.id === groupId) {
          return {
            ...g,
            choices: [
              ...g.choices,
              { id: Date.now() + Math.random(), name: '', price: '', maxQty: '' }
            ]
          };
        }
        return g;
      })
    );
  };

  const handleRemoveChoice = (groupId, choiceId) => {
    updateGroups(
      groups.map((g) => {
        if (g.id === groupId) {
          return {
            ...g,
            choices: g.choices.filter((c) => c.id !== choiceId)
          };
        }
        return g;
      })
    );
  };

  const handleChoiceChange = (groupId, choiceId, field, value) => {
    updateGroups(
      groups.map((g) => {
        if (g.id === groupId) {
          return {
            ...g,
            choices: g.choices.map((c) =>
              (c.id === choiceId ? { ...c, [field]: value } : c))
          };
        }
        return g;
      })
    );
  };

  return {
    groups,
    setGroups: updateGroups,
    isHidden,
    setIsHidden,
    toggleHidden,
    handleAddSubItem,
    handleRemoveGroup,
    handleGroupTitleChange,
    handleSelectionModeChange,
    handleRequiredToggle,
    handleAddChoice,
    handleRemoveChoice,
    handleChoiceChange,
  };
}
